import { render, staticRenderFns } from "./call-direction.vue?vue&type=template&id=743acd9e&scoped=true"
import script from "./call-direction.vue?vue&type=script&lang=js"
export * from "./call-direction.vue?vue&type=script&lang=js"
import style0 from "./call-direction.vue?vue&type=style&index=0&id=743acd9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743acd9e",
  null
  
)

export default component.exports